export class Indice {
    ind_id: string;
    ind_pay_id: string;
    ind_type: string;
    ind_base: string;
    ind_indice: string;
    ind_date_valeur: string;

    constructor(init?: Partial<Indice>) {
        Object.assign(this, init);
    }
}
